export const getChangeSituation = state => state.data.changeSituation;
